import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
//import Authorization from "./Authorization/Authorization";
//import Contacts from "./Contacts/Contacts";
import RTContacts from "./Contacts/RTContacts/RTContacts";
import Energy from "./Energy/Energy";
import VerticalTabs from "./Parameters/VerticalTabs";
import VerticalTabsStructure from "./Structure/VerticalTabsStructure";
import VerticalTabsEquipments from "./Equipments/VerticalTabsEquipments";
import VerticalTabsTertiaryBill from "../Generic/TertiaryBill/VerticalTabsTertiaryBill";
import VerticalTabsUsage from "../Generic/Usage/VerticalTabsUsage";
import MBM from "../Generic/MBM/MBM";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
    marginLeft: "15px",
    marginRight: "15px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

export default function ZoneTabs(props) {
  const memv2versionactive = localStorage.getItem('memv2version');
  const currentusertype = localStorage.getItem('userType');
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            initialselectedindex={0}
            scrollButtons="auto"
          >
            <StyledTab label="Paramètres Géneraux" value={0} />
            <StyledTab label="Contacts" value={1} />
            <StyledTab label="Fluides" value={2} />
            {currentusertype == 1 && <StyledTab label="Usages" value={6} />}
            {memv2versionactive > 0 ? <StyledTab label="Structure" value={3} /> : <></>}
            {memv2versionactive > 0 ? <StyledTab label="Equipements" value={4} /> : <></>}
            {memv2versionactive > 0 ? <StyledTab label="Dispositif Eco énergie tertiaire" value={5} /> : <></>}
            {currentusertype == 1 && <StyledTab label="Pilotage" value={7} />}

          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        <TabPanel value={0}>{<VerticalTabs />}</TabPanel>
        <TabPanel value={1}>{<RTContacts />}</TabPanel>
        <TabPanel value={2}>{<Energy />}</TabPanel>
        <TabPanel value={6}>{<VerticalTabsUsage />}</TabPanel>
        {memv2versionactive > 0 ? <TabPanel value={3}>{<VerticalTabsStructure />}</TabPanel> : <></>}
        {memv2versionactive > 0 ? <TabPanel value={4}>{<VerticalTabsEquipments />}</TabPanel> : <></>}
        {memv2versionactive > 0 ? <TabPanel value={5}>{<VerticalTabsTertiaryBill />}</TabPanel> : <></>}
        {currentusertype == 1 ? <TabPanel value={7}>{<MBM />}</TabPanel> : <></>}

      </div>
    </TabContext>
  );
}
